import React from 'react'
import { useSelector } from 'react-redux';
import hourGlass from "../../../../images/hourglass_image.png";

//Dependencies.
import { challengesState } from '../../../../slices/challengesSlice';


const LoadingChallengeDetails = () => {
   const isLoading = useSelector(challengesState).isLoading;
   return (
      <div>
         <div style={{display: 'flex', justifyContent: 'center', width: '25%', height: '25%'}}>
            <img src={hourGlass} className='img-fluid' alt='hour glass pic' />
         </div>
         <div>
            <h1>LOADING: { isLoading }</h1>
         </div>
      </div>
   )
}

export default LoadingChallengeDetails